import React, { useContext } from 'react'
// import styled from 'styled-components/macro'
import styled from '@emotion/styled'
import {
  GelHeading1,
  GelParagraph,
  GelButton,
  GelLabel,
  GelScreenDetectorContext
} from '@tal-gel/components'

import { Hero as HeroComponent } from '../Shared/Components'
import Logo from '../../components/Logo/Logo'

// TODO check if needed, clean
// import SmallCheckbox from '../../components/SmallCheckbox/SmallCheckbox'
// import { Popup, PopupText } from '../../components/Input/Popup'

// const CheckWrapper = styled.div`
//   position: relative;
//   margin-top: 1rem;

//   & > div:first-of-type {
//     top: calc(-100% + -24px);
//   }
// `

// const Hero = ({ goToSurvey, accepted, onAccept, popupShown, demo }) => (

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > h1 {
    font-size: 28px;
    line-height: 32px;
  }

  @media only screen and (min-width: 576px) {
    & > p {
      max-width: 385px;
    }

    & > h1 {
      max-width: 500px;
      font-size: 40px;
      line-height: 48px;
    }
  }
`

const LogoWrapper = styled.div`
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  margin-bottom: 40px;

  & > img {
    width: 44px;
  }
`

const Hero = ({ goToSurvey, demo }) => {
  const { screen, isLargerThanSmScreen } = useContext(GelScreenDetectorContext)

  return (
    <HeroComponent demo={demo}>
      <InnerWrapper>
        {!isLargerThanSmScreen(screen) && (
          <LogoWrapper>
            <Logo version='cbus' />
          </LogoWrapper>
        )}
        <GelHeading1 inverse textAlign='center' marginBottom={8}>
          Take five for your health and be rewarded
        </GelHeading1>
        <GelParagraph
          large
          inverse
          textAlign='center'
          marginBottom={32}
          style={{ fontWeight: 400, lineHeight: '20px' }}
        >
          Complete the TAL Health Sense quiz to find out what checks might be
          right for you.
        </GelParagraph>
        <GelButton
          primary
          large
          iconRight='ArrowRight'
          onClick={goToSurvey}
          style={{ fontSize: '12px', minHeight: '56px' }}
        >
          Begin Survey
        </GelButton>
        <GelLabel
          small
          inverted
          style={{ color: '#fff', fontWeight: 400 }}
          marginTop={16}
          textAlign='center'
        >
          By clicking this button, you confirm that you have read and agree to
          the Terms of Use.
        </GelLabel>
        {/* TODO check if needed */}
        {/* <CheckWrapper>
      {popupShown && (
        <Popup white>
        <PopupText white>
        Please confirm that you agree to the Terms of Use
        </PopupText>
        </Popup>
        )}
        <SmallCheckbox
        accepted={accepted}
        onClick={onAccept}
        text='By clicking this button, you confirm that you have read and agree to the Terms of Use.'
        white
        />
      </CheckWrapper> */}
      </InnerWrapper>
    </HeroComponent>
  )
}

export default Hero
